import styled from 'styled-components';

export const Wrapper = styled.div`
  &&& {
    .setur-segmented-item-label {
      color: ${({ theme }) => theme.palette.grey800};
      text-align: center;
      font-size: 12px;
      font-weight: 500;
      line-height: 16px;
      padding: 10px 32px;
    }

    .setur-segmented-item {
      min-width: 146px;
    }

    .setur-segmented-item.setur-segmented-item-selected
      .setur-segmented-item-label {
      color: ${({ theme }) => theme.palette.grey1100};
      font-weight: 600;
    }
  }
`;
